import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { safeValue, ConfigService, buildPath } from '@identic/core';
import { BaseService } from '@identic/api';
import { SynonymViewModel, SYNONYM_DISPLAY_FIELD } from './+state';
import { SynonymConstants } from './data-access.constants';

// R(oute)T(oken)
const RT = SynonymConstants;

@Injectable({providedIn: 'root'})
export class SynonymService extends BaseService<SynonymViewModel> {

  constructor(http: HttpClient, config: ConfigService) {
    super(http, buildPath(config.environment.API_BASE_URL, safeValue(config, 'environment.Api.Synonym', RT.defaultApi)), SYNONYM_DISPLAY_FIELD);
  }
}
